import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Location } from '@angular/common';
import { error } from 'console';

@Component({
  selector: 'app-payment-gateway',
  templateUrl: './payment-gateway.component.html',
  styleUrls: ['./payment-gateway.component.scss']
})
export class PaymentGatewayComponent implements OnInit {

  atRegisterForm = false;

  file: any;
  files = [];
  data: any;
  libraryForm: FormGroup;
  isUpdateData: any;
  @ViewChild('fileSet', { static: true }) fileSet: any;
  couponId: any;
  total_discounted_amount: any;
  fileUrl = [];
  accountDetailsArr = [
    {
      label: 'ACCOUNT NAME',
      value: 'FOGSI - MANYATA',
    },
    {
      label: 'ACCOUNT NUMBER',
      value: '24480100027717',
    },
    {
      label: 'BANK NAME',
      value: 'BANK OF BARODA',
    },
    {
      label: 'IFSC CODE',
      value: 'BARB0JACOBC (Fifth character is zero)',
    },
    {
      label: 'BRANCH',
      value: 'JACOB CIRCLE BRANCH',
    },
  ];

  constructor(private router: Router,
    private _activateRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private location: Location,
    private el: ElementRef) {

    this.createForm();
    // this.authService.getcouponDetails().subscribe((res: any) => {
    //   console.log('couponDetails in payment', res['couponId'], res['total_discounted_amount']);
    //   // this.couponId = res?.couponId;
    //   // this.total_discounted_amount = res?.total_discounted_amount;
    //   this.couponId = res?.couponId !== '' || res?.couponId !== undefined ? res?.couponId : this.couponId;
    //   this.total_discounted_amount = res?.total_discounted_amount !== '' || res?.total_discounted_amount !== undefined ? res?.total_discounted_amount : this.total_discounted_amount;
    // })


  }

  ngOnInit(): void {
    this.authService.getUserDetail(sessionStorage.getItem('userId'), sessionStorage.getItem("token")).subscribe((res: any) => {
      this.couponId = res?.data?.coupon_id !== null ? res?.data?.coupon_id : null
      this.total_discounted_amount = res?.data?.coupon?.discount !== null && res?.data?.coupon?.discount !== undefined ? 20000 - res?.data?.coupon?.discount : 20000;
    })
    setTimeout(() => {
      console.log(this.couponId, this.total_discounted_amount);
    }, 2000)
  }

  // getUploadedPdf(event) {
  //   console.log(event)
  //   if (event) {
  //     this.file = event[0];
  //   }
  // }

  createForm() {
    this.libraryForm = this.formBuilder.group({
      files: ['', [Validators.required]],
    });
    // console.log('data', this.libraryForm.value)
  }

  onFileDropped($event) {
    // this.files = [];
    this.prepareFilesList($event);
    // if ($event) {
    //   this.file = $event[0];
    // }
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    // this.files = [];

    this.prepareFilesList(files);
    console.log('files', files)
    // if (files) {
    //   this.file = files[0];
    // }
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);

    if (this.files.length == 0) {
      this.libraryForm.reset();
    }
  }

  /**
 * Simulate the upload process
 */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }



  paylaterClick() {
    this.router.navigateByUrl('welcome-login');
  }

  submitClick() {
    // console.log(this.files);
    // console.log(this.fileUrl);

    this.files.map((file) => {
      let awsBody = [{
        "file_name": file.name,
        "mime_type": file.type
      }]

      this.authService.awsRequest(awsBody).subscribe((response1: any) => {
        this.authService.awsResponseUrl(response1?.data[0]?.url, file).subscribe((response2: any) => {
          // console.log('awsResponseUrl', res);
          this.fileUrl.push(response1?.data[0]?.file_url);
          this.submitValues();
        },
          (error) => {
            Swal.fire('Error', `${error.error.message}`, 'error');
          })
      },
        (error) => {
          Swal.fire('Error', `${error.error.message}`, 'error');
        })
    })

  }

  submitValues() {

    let payload = {
      'payment_date': new Date(),
      'user_id': +sessionStorage.getItem('userId'),
      'coupon_id': this.couponId,
      'total_amount': this.total_discounted_amount,
      'payment_reciept': this.fileUrl.toString(),             //Converting array elements to , separated
    }

    this.authService.paymentReceipt(payload).subscribe((res: any) => {
      Swal.fire("Success", 'Your Receipt Successfully Submitted', 'success').then(() => {
        this.router.navigateByUrl('welcome-login');
      })
      this.libraryForm.reset();
      this.fileUrl = [];
    },
      (error) => {
        Swal.fire("error", error.error.message, 'error')
      })
  }
}
